import React, {useEffect, useState} from 'react'
import {registerShape} from '@antv/g2'
import Chart from '@components/chart'

export default function EnergyStatisticsItem({
  title = '',
  chartData,
}) {
  const [energyChartData, setEnergyChartData] = useState(null)

  const renderChart = (instance, opts) => {
    registerShape('point', 'pointer', {
      draw(cfg, container) {
        const group = container.addGroup({});
        // 获取极坐标系下画布中心点
        const center = this.parsePoint({x: 0, y: 0});
        // 绘制指针
        group.addShape('line', {
          attrs: {
            x1: center.x,
            y1: center.y,
            x2: cfg.x,
            y2: cfg.y,
            stroke: cfg.color,
            lineWidth: 5,
            lineCap: 'round',
          },
        });
        group.addShape('circle', {
          attrs: {
            x: center.x,
            y: center.y,
            r: 9.75,
            stroke: cfg.color,
            lineWidth: 4.5,
            fill: '#fff',
          },
        });
    
        return group;
      },
    });
    const color = ['#00EEE0', '#0595FF', '#FF9600'];
    instance.data(opts.data);
    instance.animate(false);

    instance.coordinate('polar', {
      startAngle: (-9 / 8) * Math.PI,
      endAngle: (1 / 8) * Math.PI,
      radius: 0.75,
    });
    instance.scale('value', {
      min: 0,
      max: opts.data[0].value == 0 ? 100 : (Math.ceil(opts.data[0].value/100)*100),
      tickInterval: opts.data[0].value == 0 ? 20 : (Math.ceil(opts.data[0].value/100)*20),
    });

    instance.axis('1', false);
    instance.axis('value', {
      line: null,
      label: {
        offset: -40,
        style: {
          fontSize: 18,
          fill: '#CBCBCB',
          textAlign: 'center',
          textBaseline: 'middle',
        },
      },
      tickLine: {
        length: -15,
      },
      grid: null,
    });
    instance.legend(false);
    instance.tooltip(false);
    instance
      .point()
      .position('value*1')
      .shape('pointer')
      .color('value', (val) => {
        if (val < 100) {
          return color[0];
        } else if (val <= 300) {
          return color[1];
        } else if (val <= 500) {
          return color[2];
        }
        return color[2];
      });

    draw(opts.data);

    function draw(data) {
      console.log('data--', data)
      const val = data[0].value;
      const lineWidth = 10;
      instance.annotation().clear(true);
      // 绘制仪表盘背景
      instance.annotation().arc({
        top: false,
        start: [0, 1],
        end: [opts.data[0].value == 0 ? 100 : (Math.ceil(opts.data[0].value/100)*100), 1],
        style: {
          stroke: '#CBCBCB',
          lineWidth,
          lineDash: null,
        },
      });

      if (val >= 200) {
        instance.annotation().arc({
          start: [0, 1],
          end: [val, 1],
          style: {
            stroke: color[0],
            lineWidth,
            lineDash: null,
          },
        });
      }

      if (val >= 400) {
        instance.annotation().arc({
          start: [2, 1],
          end: [4, 1],
          style: {
            stroke: color[1],
            lineWidth,
            lineDash: null,
          },
        });
      }

      if (val > 400 && val <= 600) {
        instance.annotation().arc({
          start: [4, 1],
          end: [val, 1],
          style: {
            stroke: color[2],
            lineWidth,
            lineDash: null,
          },
        });
      }

      if (val > 200 && val <= 400) {
        instance.annotation().arc({
          start: [2, 1],
          end: [val, 1],
          style: {
            stroke: color[1],
            lineWidth,
            lineDash: null,
          },
        });
      }

      if (val < 200) {
        instance.annotation().arc({
          start: [0, 1],
          end: [val, 1],
          style: {
            stroke: color[0],
            lineWidth,
            lineDash: null,
          },
        });
      }

      // 绘制指标数字
      instance.annotation().text({
        position: ['50%', '90%'],
        content: 'kwh',
        style: {
          fontSize: 20,
          fill: '#01F7FD',
          textAlign: 'center',
        },
      });
      // instance.annotation().text({
      //   position: ['50%', '90%'],
      //   content: `${data[0].value * 10} %`,
      //   style: {
      //     fontSize: 36,
      //     fill: '#545454',
      //     textAlign: 'center',
      //   },
      //   offsetY: 15,
      // });
      instance.changeData(data);
    }
  }
  
  useEffect(() => {
    console.log('chartData--', chartData)
    if (chartData && chartData.length) {
      setEnergyChartData(chartData)
    }
  }, [chartData])

  return (
    <div className="energy-st-item">
      <div className="energy-item-title">
        {title}
      </div>
      <div className="energy-item-chart">
        {
          energyChartData ? (
            <Chart renderChart={renderChart} style={{height: 180}} data={energyChartData} />
          ) : null
        }
        <div style={{color: '#01f4fb', fontSize: '25px', textAlign: 'center'}}>{chartData ? (chartData[0].value).toFixed(2) : null}kwh</div>
      </div>
    </div>
  )
}